import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {useVuplex} from '../../hooks/useVuplex';
import {isNewDataAvailableSet, pinEditFormSet, pinUnsavedTempSet} from '../../reducers/pinsReducer';

const PinsVuplex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {pathname} = useLocation();

  const isEditingPin = pathname.endsWith('pins/edit');
  const isPanoIdSearch = /pins\/panoId\/.+/.test(pathname);

  useVuplex({
    panoIdSearchRequest: ({data}) => {
      dispatch(pinUnsavedTempSet({
        ...data,
        label: data._id
          ? data.label
          : data.label || data.suggestedLabel,
      }));

      navigate(`panoId/${data.streetViewId}`, {replace: isPanoIdSearch});
    },
    pinEditRequest: ({data}) => {
      dispatch(pinEditFormSet({
        ...data,
        label: data._id
          ? data.label
          : data.label || data.suggestedLabel,
      }));

      if (!isEditingPin) {
        navigate('pins/edit');
      }
    },
    pinNewData: () => {
      dispatch(isNewDataAvailableSet(true));
    },
  }, [isEditingPin, isPanoIdSearch]);

  return null;
};

export default PinsVuplex;
